export const FOOTER_PAGE_TYPE = {
  GLOBAL: 'global_page',
  HOME: 'home_page',
  CATEGORY: 'category_page',
  SEARCH: 'search_page',
  BLOG: 'blog_page',
  PDP: 'pdp_page',
} as const;

export type TFooterPageType = (typeof FOOTER_PAGE_TYPE)[keyof typeof FOOTER_PAGE_TYPE];

export const FOOTER_PAGE_TYPE_BY_ROUTE_PREFIX: ReadonlyArray<[string, TFooterPageType]> = [
  ['/category', FOOTER_PAGE_TYPE.CATEGORY],
  ['/search', FOOTER_PAGE_TYPE.SEARCH],
  ['/blog', FOOTER_PAGE_TYPE.BLOG],
  ['/product', FOOTER_PAGE_TYPE.PDP],
];
